module.exports = __webpack_public_path__ + "static/media/headimage3.d7ae2441.jpg";